import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { CheckoutPageId } from 'checkout/constants/pages'
import productLabels from 'i18n/productLabels'

export function useCruiseCheckoutStepLabels(): Record<string, string> {
  const intl = useIntl()
  return useMemo(() => ({
    passengers: intl.formatMessage({
      id: 'QMt9Ky-29V572fUSZB4Y',
      defaultMessage: 'Passengers',
      description: 'Cruise checkout step label for passenger details in the checkout cruise selection',
    }),
    typeAndCategory: intl.formatMessage({
      id: 'cIl-X-O470CdwaGgrLoh',
      defaultMessage: 'Type & Category',
      description: 'Cruise checkout step label for cabin type and category selection',
    }),
    cabinType: intl.formatMessage({
      id: 'KqbiOHj3W-wZC35b4NXu',
      defaultMessage: 'Cabin type',
      description: 'Cruise checkout sub-step label for cabin type selection',
    }),
    cabinCategory: intl.formatMessage({
      id: 'UKuJkpUXybG12EJmuLmS',
      defaultMessage: 'Cabin category',
      description: 'Cruise checkout sub-step label for cabin category selection',
    }),
    location: intl.formatMessage({
      id: 'o-n20p4P0Z2OdLccSjOa',
      defaultMessage: 'Location',
      description: 'Cruise checkout step label for cabin location selection',
    }),
    package: intl.formatMessage({
      id: 'cl53tl3o9QzagrHfVyZZ',
      defaultMessage: 'Package',
      description: 'Cruise checkout step label for cabin package selection',
    }),
    luxPlus: intl.formatMessage(productLabels.luxPlus),
    hotels: intl.formatMessage(productLabels.hotels),
    reviewAndPayment: intl.formatMessage({
      id: 'E2P23t6HJ7LLe9Vxk40c',
      defaultMessage: 'Review & Payment',
      description: 'Cruise checkout step label for review and payment in the checkout cruise selection',
    }),
  }), [intl])
}

export const CRUISE_CHECKOUT_HEADER_STEPS: Array<App.Checkout.CheckoutStep> = [
  {
    label: 'passengers',
    key: CheckoutPageId.CruiseTravelers,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'typeAndCategory',
    key: 'cabin-type-category',
    subSteps: [
      {
        label: 'cabinType',
        key: CheckoutPageId.CruiseCabinType,
        isRoute: true,
      },
      {
        label: 'cabinCategory',
        key: CheckoutPageId.CruiseCabinCategory,
        isRoute: true,
      },
    ],
    isRoute: true,
  },
  {
    label: 'location',
    key: CheckoutPageId.CruiseCabinLocation,
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'package',
    key: CheckoutPageId.CruiseCabinPackage,
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'luxPlus',
    key: CheckoutPageId.LuxPlus,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'hotels',
    key: CheckoutPageId.CruiseHotelRecommendation,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'reviewAndPayment',
    key: CheckoutPageId.Purchase,
    subSteps: [],
    isRoute: true,
  },
]
